// ============================================================================
// backendAuthFetch — anexa o LOGIN (ID token do Firebase) a toda chamada `fetch` feita
// ao servidor Python (Render / local).
//
// Por que existe (auditoria de seguranca de 21/09/2026): o servidor Python nao exigia login
// na maioria das rotas do Drive (listar, apagar, tornar publico...). Ele passa a exigir
// administrador nas rotas destrutivas (variavel RDA_ENFORCE_ADMIN_DESTRUCTIVE=1 no Render),
// e para isso o site precisa enviar o token em TODA chamada — em vez de editar as ~90
// chamadas espalhadas em 30 arquivos, este arquivo intercepta o `fetch` num unico ponto.
//
// Regras de seguranca deste arquivo:
//   - so anexa o token a chamadas para o servidor do escritorio (lista fechada abaixo);
//     nunca para outros dominios;
//   - nao sobrescreve um Authorization que a chamada ja tenha;
//   - se nao houver usuario logado, ou se algo falhar, a chamada segue como antes.
// ============================================================================
import { auth } from '../shared/api/firebase/config';

const HOSTS_BACKEND = new Set(['rda-backend-thuq.onrender.com']);

function origemDoEnv() {
  try {
    const u = import.meta?.env?.VITE_BACKEND_URL;
    return u ? new URL(u).host : null;
  } catch {
    return null;
  }
}

function ehServidorDoEscritorio(urlStr) {
  try {
    const u = new URL(urlStr, window.location.href);
    if (HOSTS_BACKEND.has(u.host)) return true;
    const doEnv = origemDoEnv();
    if (doEnv && u.host === doEnv) return true;
    // servidor local de desenvolvimento (portas 80xx)
    return /^(localhost|127\.0\.0\.1):80\d\d$/.test(u.host);
  } catch {
    return false;
  }
}

export function installBackendAuthFetch() {
  if (typeof window === 'undefined' || window.__rdaBackendAuthFetch) return;
  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input, init) => {
    try {
      const url = typeof input === 'string' ? input : input?.url;
      if (url && ehServidorDoEscritorio(url)) {
        const user = auth.currentUser;
        if (user) {
          const base = init?.headers ?? (typeof input !== 'string' ? input.headers : undefined);
          const headers = new Headers(base);
          if (!headers.has('Authorization')) {
            headers.set('Authorization', `Bearer ${await user.getIdToken()}`);
            init = { ...(init || {}), headers };
          }
        }
      }
    } catch {
      // nunca quebra a chamada original por causa do token
    }
    return originalFetch(input, init);
  };

  window.__rdaBackendAuthFetch = true;
}
